/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTargetIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-target"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12.01 22.32Q12.01 22.32 10.94 22.32Q9.88 22.32 7.99 21.51Q6.1 20.7 4.7 19.3Q3.3 17.9 2.49 16.01Q1.68 14.13 1.68 11.99Q1.68 9.85 2.49 7.97Q3.3 6.1 4.7 4.7Q6.1 3.3 7.99 2.49Q9.88 1.68 12.01 1.68Q14.15 1.68 16.02 2.49Q17.9 3.3 19.3 4.7Q20.7 6.1 21.51 7.97Q22.32 9.85 22.32 11.99Q22.32 14.13 21.51 16.01Q20.7 17.9 19.3 19.3Q17.9 20.7 16.02 21.51Q14.15 22.32 12.01 22.32ZM12 19.68Q12 19.68 13.6 19.68Q15.2 19.68 17.44 17.44Q19.68 15.2 19.68 12Q19.68 8.8 17.44 6.56Q15.2 4.33 12 4.33Q8.8 4.33 6.56 6.56Q4.33 8.8 4.33 12Q4.33 15.2 6.56 17.44Q8.8 19.68 12 19.68ZM12 18.32Q12 18.32 10.68 18.32Q9.35 18.32 7.51 16.49Q5.67 14.65 5.67 12Q5.67 9.35 7.51 7.51Q9.35 5.67 12 5.67Q14.65 5.67 16.49 7.51Q18.32 9.35 18.32 12Q18.32 14.65 16.49 16.49Q14.65 18.32 12 18.32ZM12 15.68Q12 15.68 12.76 15.68Q13.53 15.68 14.6 14.6Q15.68 13.53 15.68 12Q15.68 10.47 14.6 9.4Q13.53 8.32 12 8.32Q10.47 8.32 9.4 9.4Q8.32 10.47 8.32 12Q8.32 13.53 9.4 14.6Q10.47 15.68 12 15.68ZM12 14.32Q12 14.32 11.53 14.32Q11.05 14.32 10.36 13.64Q9.68 12.95 9.68 12Q9.68 11.05 10.36 10.36Q11.05 9.68 12 9.68Q12.95 9.68 13.64 10.36Q14.32 11.05 14.32 12Q14.32 12.95 13.64 13.64Q12.95 14.32 12 14.32Z" fill={color} />
    </svg>
  );
}
